module.exports = __webpack_public_path__ + "img/popular-categories-6.345bcd5d.png";